'use client';

import { useEffect, useRef } from 'react';
import { EVENTS, track } from '@/lib/analytics';

interface Props {
  primaryId: string;
  secondaryId: string;
  pairKind: string;
  tier: 'A' | 'B';
  verdict: string;
}

/** Fires `gear_pair_viewed` once per page view, with the engine's verdict so
 *  the funnel can be read by answer (does a "not recommended" page still
 *  send people into the editor?). Renders nothing. */
export default function GearPairViewed({ primaryId, secondaryId, pairKind, tier, verdict }: Props) {
  // Guards React's development double-invoke; a client-side navigation to
  // another pair changes the key and counts as a new view.
  const sent = useRef<string | null>(null);
  useEffect(() => {
    const key = `${primaryId}|${secondaryId}`;
    if (sent.current === key) return;
    sent.current = key;
    track(EVENTS.gear_pair_viewed, { primary_id: primaryId, secondary_id: secondaryId, pair_kind: pairKind, tier, verdict });
  }, [primaryId, secondaryId, pairKind, tier, verdict]);
  return null;
}
